import React, { useState } from 'react';
import ReactLoading from 'react-loading';
import LocalizedMessage from 'react-l10n';
import ReactTableWrapper from '../../ReactTableWrapper';

function AccountPICNumberList(props) {
    const { isLoading, list, onRemoveClick, onMakeDefaultClick } = props;
    const [
        showRemoveConfirmationModal,
        setShowRemoveConfirmationModal,
    ] = useState({});
    const [isDeleting, setIsDeleting] = useState({});
    const [isDefaulting, setIsDefaulting] = useState({});

    let defaultRefs = {};

    /**
     * Toggle isDefaulting value
     *
     * @param key
     * @param value
     */
    const toggleIsDefaulting = (key, value) => {
        setIsDefaulting({
            ...isDefaulting,
            [key]: value,
        });
    };

    /**
     * Toggle isDeleting value
     *
     * @param key
     * @param value
     */
    const toggleIsDeleting = (key, value) => {
        setIsDeleting({
            ...isDeleting,
            [key]: value,
        });
    };

    /**
     * Handler when user confirms removing a row
     *
     * @param row
     */
    const onConfirmRemoveRow = (row) => {
        const identifier = row.original.ID;

        toggleShowRemoveConfirmationModal(row, false);
        toggleIsDeleting(identifier, true);

        onRemoveClick(identifier, {
            always: () => {
                toggleIsDeleting(identifier, false);
            },
        });
    };

    /**
     * Handler when user clicks make default button
     *
     * @param row
     */
    const handleMakeDefault = (row) => {
        const identifier = row.original.ID;

        // lose focus
        defaultRefs[identifier].blur();

        toggleIsDefaulting(identifier, true);
        onMakeDefaultClick(identifier, {
            always: () => {
                toggleIsDefaulting(identifier, false);
            },
        });
    };

    /**
     * Toggle the show remove confirmation modal
     *
     * @param row
     * @param value
     */
    const toggleShowRemoveConfirmationModal = (row, value) => {
        const { viewIndex } = row;

        setShowRemoveConfirmationModal({
            ...showRemoveConfirmationModal,
            [viewIndex]: value,
        });
    };

    /**
     * Check if we are showing remove confirmation on this row
     *
     * @param row
     * @returns {boolean}
     */
    const getRemoveConfirmation = (row) => {
        const { viewIndex } = row;

        return typeof showRemoveConfirmationModal[viewIndex] != 'undefined'
            ? showRemoveConfirmationModal[viewIndex]
            : false;
    };

    /**
     * Get the React Table props
     *
     * @returns {{list: {columns: *[], showPagination: boolean}}}
     */
    const getTableProps = () => {
        // const lessThanMD = wWidth < breakpoints.md;
        const tableProps = {
            list: {
                columns: [
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'PIC_NUMBERS'} />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'rt-pic-numbers__number',
                        className: 'rt-pic-numbers__number',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Title',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'BUSINESS_NAME'}
                                        />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'rt-pic-numbers__business-name',
                        className: 'rt-pic-numbers__business-name',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'BusinessName',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'FIRST_NAME'} />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'rt-pic-numbers__first-name hidden-xs',
                        className: 'rt-pic-numbers__first-name hidden-xs',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'FirstName',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'LAST_NAME'} />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'rt-pic-numbers__last-name hidden-xs',
                        className: 'rt-pic-numbers__last-name hidden-xs',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'LastName',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'TOWN'} />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'rt-pic-numbers__town hidden-xs',
                        className: 'rt-pic-numbers__town hidden-xs',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Town',
                    },
                    // {
                    //     Header: () => {
                    //         return (
                    //             <React.Fragment>
                    //                 <span className='react-table__heading'>
                    //                     <LocalizedMessage id={'DEFAULT'} />
                    //                 </span>
                    //             </React.Fragment>
                    //         );
                    //     },
                    //     Cell: (row) => {
                    //         const identifier = row.original.ID;
                    //         const isColumnLoading =
                    //             typeof isDefaulting[identifier] != 'undefined'
                    //                 ? isDefaulting[identifier]
                    //                 : false;
                    //         const hasOtherAction =
                    //             typeof isDeleting[identifier] != 'undefined'
                    //                 ? isDeleting[identifier]
                    //                 : false;
                    //
                    //         if (hasOtherAction) {
                    //             return '';
                    //         }
                    //
                    //         return (
                    //             <React.Fragment>
                    //                 {isColumnLoading ? (
                    //                     <ReactLoading
                    //                         type='spin'
                    //                         color='black'
                    //                         height={20}
                    //                         width={20}
                    //                     />
                    //                 ) : (
                    //                     <React.Fragment>
                    //                         {row.value == 1 ? (
                    //                             <button
                    //                                 ref={(r) => {
                    //                                     defaultRefs[
                    //                                         identifier
                    //                                     ] = r;
                    //                                 }}
                    //                                 type='button'
                    //                                 className='button-set-default button-set-default--active'
                    //                                 onClick={(e) =>
                    //                                     e.preventDefault()
                    //                                 }
                    //                             >
                    //                                 <span className='icon icon-check-thick' />
                    //                             </button>
                    //                         ) : (
                    //                             <button
                    //                                 ref={(r) => {
                    //                                     defaultRefs[
                    //                                         identifier
                    //                                     ] = r;
                    //                                 }}
                    //                                 type='button'
                    //                                 className='button-set-default'
                    //                                 onClick={(e) =>
                    //                                     handleMakeDefault(row)
                    //                                 }
                    //                             >
                    //                                 <span className='icon icon-check-thick' />
                    //                             </button>
                    //                         )}
                    //                     </React.Fragment>
                    //                 )}
                    //             </React.Fragment>
                    //         );
                    //     },
                    //     headerClassName: 'react-table__make-default-col',
                    //     className: 'react-table__make-default-col',
                    //     minWidth: undefined,
                    //     sortable: false,
                    //     accessor: 'IsDefault',
                    // },
                    {
                        Cell: (row) => {
                            const identifier = row.original.ID;
                            const isColumnLoading =
                                typeof isDeleting[identifier] != 'undefined'
                                    ? isDeleting[identifier]
                                    : false;
                            const hasOtherAction =
                                typeof isDefaulting[identifier] != 'undefined'
                                    ? isDefaulting[identifier]
                                    : false;

                            if (hasOtherAction) {
                                return '';
                            }

                            return (
                                <React.Fragment>
                                    {isColumnLoading ? (
                                        <ReactLoading
                                            type='spin'
                                            color='black'
                                            height={20}
                                            width={20}
                                        />
                                    ) : (
                                        <button
                                            type='button'
                                            className='button-link-plain button-link-plain--light-grey button-link-plain--small'
                                            onClick={(e) =>
                                                toggleShowRemoveConfirmationModal(
                                                    row,
                                                    true
                                                )
                                            }
                                        >
                                            <span className='icon icon-bin-thick' />
                                        </button>
                                    )}
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'react-table__remove-col hidden-xs',
                        className: 'react-table__remove-col hidden-xs',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'IsDelete',
                    },
                    {
                        expander: true,
                        Expander: ({ isExpanded, ...rest }) => {
                            return (
                                <React.Fragment>
                                    <button
                                        type='button'
                                        className='react-table__extra-data-toggle'
                                    >
                                        <span className='icon icon-chevron-thick' />
                                    </button>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'visible-xs',
                        className: 'visible-xs',
                        width: 45,
                        sortable: false,
                        accessor: 'ID',
                    },
                ],
                showPagination: false,
                SubComponent: (row) => {
                    const { ID, FirstName, LastName, Town } = row.original;
                    const isDeleteColumnLoading =
                        typeof isDeleting[ID] != 'undefined'
                            ? isDeleting[ID]
                            : false;
                    const hasOtherAction =
                        typeof isDefaulting[ID] != 'undefined'
                            ? isDefaulting[ID]
                            : false;

                    return (
                        <React.Fragment>
                            <div className='react-table__extra-data'>
                                <div className='row'>
                                    <div className='col-xs-6 vspace vspace--small'>
                                        <div className='data-table__heading'>
                                            <LocalizedMessage
                                                id={'FIRST_NAME'}
                                            />
                                        </div>
                                        <div className='data-table__info'>
                                            {FirstName}
                                        </div>
                                    </div>
                                    <div className='col-xs-6 vspace vspace--small'>
                                        <div className='data-table__heading'>
                                            <LocalizedMessage
                                                id={'LAST_NAME'}
                                            />
                                        </div>
                                        <div className='data-table__info'>
                                            {LastName}
                                        </div>
                                    </div>
                                    <div className='col-xs-12 vspace vspace--small'>
                                        <div className='data-table__heading'>
                                            <LocalizedMessage id={'TOWN'} />
                                        </div>
                                        <div className='data-table__info'>
                                            {Town}
                                        </div>
                                    </div>
                                    <div className='col-xs-12 vspace vspace--small'>
                                        <div className='data-table__heading'>
                                            <LocalizedMessage id={'EDIT'} />
                                        </div>
                                        <div className='data-table__info'>
                                            {!hasOtherAction ? (
                                                <button
                                                    type='button'
                                                    className='form__submit button button--grey-border'
                                                    onClick={(e) =>
                                                        toggleShowRemoveConfirmationModal(
                                                            row,
                                                            true
                                                        )
                                                    }
                                                >
                                                    {isDeleteColumnLoading ? (
                                                        <ReactLoading
                                                            className='button__spinner'
                                                            type='spin'
                                                            color='black'
                                                            height={20}
                                                            width={20}
                                                        />
                                                    ) : (
                                                        <React.Fragment>
                                                            <span className='icon icon-bin-thick' />{' '}
                                                            <LocalizedMessage
                                                                id={'DELETE'}
                                                            />
                                                        </React.Fragment>
                                                    )}
                                                </button>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                },
            },
        };

        return tableProps;
    };

    return (
        <ReactTableWrapper
            loading={isLoading}
            data={list}
            reactTable={getTableProps()}
            hasRemoveConfirmation={true}
            toggleRemoveConfirmation={toggleShowRemoveConfirmationModal}
            getRemoveConfirmation={getRemoveConfirmation}
            onRemoveRow={onConfirmRemoveRow}
        />
    );
}

export default AccountPICNumberList;
